import { FormControlOutline, FormControlUnderline } from './Select.styles';
import { InputLabel, MenuItem, Select } from '@mui/material';
import React, { ElementType, useEffect } from 'react';

import { SelectInputProps } from '@mui/material/Select/SelectInput';
import { useGlobalization } from '../../../../../../i18n/useGlobalization';
import { camelAndSnakeCaseToWords } from '../../utils/helpers';

export interface AssetTypeSelectProps {
	systemType: string;
	assetType: string;
	onAssetTypeChange: SelectInputProps<string>['onChange'];
	assetTypes: string[] | undefined;
	assetSchema: Record<string, { displayName?: string }>;
	loadAssetSchema: (assetType: string) => void;
	topBar?: boolean;
	dataCy?: string;
}

export const AssetTypeSelect = ({
	systemType,
	assetType,
	onAssetTypeChange,
	assetTypes,
	assetSchema,
	loadAssetSchema,
	topBar,
	dataCy,
}: AssetTypeSelectProps): JSX.Element => {
	const { t } = useGlobalization();

	useEffect(() => {
		if (systemType !== 'SpatialData') {
			assetTypes?.forEach(type => loadAssetSchema(type));
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [systemType, assetTypes?.join(',')]);

	const FormControl: ElementType = topBar
		? FormControlUnderline
		: FormControlOutline;

	return (
		<FormControl>
			<InputLabel shrink={topBar}>{t('Layer Name')}</InputLabel>
			<Select
				displayEmpty
				value={assetType}
				disabled={!systemType}
				onChange={onAssetTypeChange}
				data-cy={dataCy}>
				{topBar && (
					<MenuItem disabled value="">
						{t('Select a layer')}
					</MenuItem>
				)}
				{assetTypes?.map(assetType => (
					<MenuItem key={assetType} value={assetType}>
						{assetSchema[assetType]?.displayName ??
							camelAndSnakeCaseToWords(assetType)}
					</MenuItem>
				))}
			</Select>
		</FormControl>
	);
};
